import React, { useState } from 'react';
import { Button } from '../base/Button';

export const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isProductDropdownOpen, setIsProductDropdownOpen] = useState(false);
  const [isCasesDropdownOpen, setIsCasesDropdownOpen] = useState(false);

  return (
    <header className="bg-white shadow-md sticky top-0 z-50">
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex items-center">
            <a href="/" className="cursor-pointer">
              <img 
                src="https://static.readdy.ai/image/62bfd8064e11f74310ce1cc00b80d48a/fb0947f3ec26dc46b1a242335100b45e.png" 
                alt="EGE 지구환경전문가그룹" 
                className="h-12 w-auto"
                title="EGE 지구환경전문가그룹"
              />
            </a>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <a href="https://www.ege.co.kr/company/company02.asp" target="_blank" rel="noopener noreferrer" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">
              회사소개
            </a>
            <div
              className="relative"
              onMouseEnter={() => setIsProductDropdownOpen(true)}
              onMouseLeave={() => setIsProductDropdownOpen(false)}
            >
              <a href="/overview" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer flex items-center">
                Product
                <i className="ri-arrow-down-s-line ml-1"></i>
              </a>
              {isProductDropdownOpen && (
                <div className="absolute top-full left-0 mt-1 w-64 bg-white rounded-lg shadow-lg border border-gray-200 py-2">
                  <a href="/overview" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-blue-600 transition-colors cursor-pointer">
                    통합 자동화 계측
                  </a>
                  <a href="/smart-pbd" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-blue-600 transition-colors cursor-pointer">
                    스마트 P.B.D. 통합관리
                  </a>
                  <a href="/smart-dcm" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-blue-600 transition-colors cursor-pointer">
                    스마트 DCM 통합관리
                  </a>
                  <a href="/gnss-settlement" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-blue-600 transition-colors cursor-pointer">
                    지반침하 GNSS 무선 침하계
                  </a>
                </div>
              )}
            </div>
            <div
              className="relative"
              onMouseEnter={() => setIsCasesDropdownOpen(true)}
              onMouseLeave={() => setIsCasesDropdownOpen(false)}
            >
              <a href="#cases" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer flex items-center">
                현장사례
                <i className="ri-arrow-down-s-line ml-1"></i>
              </a>
              {isCasesDropdownOpen && (
                <div className="absolute top-full left-0 mt-1 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-2">
                  <a href="/cases" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-blue-600 transition-colors cursor-pointer">
                    홍보자료
                  </a>
                  <a href="https://blog.naver.com/cagito" target="_blank" rel="noopener noreferrer" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-blue-600 transition-colors cursor-pointer">
                    블로그
                  </a>
                </div>
              )}
            </div>
            <a href="/materials" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">자료실</a>
            <a href="/contact" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">문의하기</a>
          </nav>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
            >
              <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col space-y-4">
              <a href="https://www.ege.co.kr/company/company02.asp" target="_blank" rel="noopener noreferrer" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer py-2">
                회사소개
              </a>
              <div>
                <a href="/overview" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer flex items-center justify-between py-2">
                  Product
                  <i className="ri-arrow-down-s-line"></i>
                </a>
                <div className="ml-4 mt-2 space-y-2">
                  <a href="/overview" className="block text-gray-600 hover:text-blue-600 transition-colors cursor-pointer py-1">
                    통합 자동화 계측
                  </a>
                  <a href="/smart-pbd" className="block text-gray-600 hover:text-blue-600 transition-colors cursor-pointer py-1">
                    스마트 P.B.D. 통합관리
                  </a>
                  <a href="/smart-dcm" className="block text-gray-600 hover:text-blue-600 transition-colors cursor-pointer py-1">
                    스마트 DCM 통합관리
                  </a>
                  <a href="/gnss-settlement" className="block text-gray-600 hover:text-blue-600 transition-colors cursor-pointer py-1">
                    지반침하 GNSS 무선 침하계
                  </a>
                </div>
              </div>
              <div>
                <a href="#cases" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer flex items-center justify-between py-2">
                  현장사례
                  <i className="ri-arrow-down-s-line"></i>
                </a>
                <div className="ml-4 mt-2 space-y-2">
                  <a href="/cases" className="block text-gray-600 hover:text-blue-600 transition-colors cursor-pointer py-1">
                    홍보자료
                  </a>
                  <a href="https://blog.naver.com/cagito" target="_blank" rel="noopener noreferrer" className="block text-gray-600 hover:text-blue-600 transition-colors cursor-pointer py-1">
                    블로그
                  </a>
                </div>
              </div>
              <a href="/materials" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer py-2">자료실</a>
              <a href="/contact" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer py-2">문의하기</a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};
